import React, { Component } from "react";

import { Icon } from "@formant/ui/component/common/Icon";

import { TextButton } from "../common/TextButton";
import * as styles from "./TooMuchData.scss";

interface ITooMuchDataProps {
    onResetTimeSpan?: () => void;
}
export class TooMuchData extends Component<ITooMuchDataProps> {
    public render() {
        const { onResetTimeSpan } = this.props;
        return (
            <div
                className={styles["too-much-data"]}
                data-tooltip="There is too much data to display here. Try adjusting your filter"
            >
                <Icon name="warning" />
                Data limit exceeded
                {onResetTimeSpan && (
                    <>
                        {". "}
                        <TextButton onClick={onResetTimeSpan}>
                            Reset time range
                        </TextButton>
                    </>
                )}
            </div>
        );
    }
}
